// extracted by mini-css-extract-plugin
export default {"first":"#0a4d28","productTextBody":"Tralki_productTextBody__Je8KO","green":"Tralki_green__bC88f"};